<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="lossOfUseItemsForm">
      <div class="">
        <h3 class="form_name">Loss Of Use Items</h3>


          <div class="input">
            <label for="">Loss Of Use Desc.</label>
            <input type="text" class="default_input reference-form" formControlName="LossOfUseItemDesc" />
            <label for="">Rate</label>
            <input type="text" class="default_input reference-form" formControlName="Rate" />
            <label for="">Measure</label>
            <select class="default_input reference-form" formControlName="UomId" (change)="onSelectLossOfUse($event.target.value)" #measure style="width: 100%">
                <option value=""> Select Measure </option>
                    <option *ngFor="let measure of measurelist"  [value]="measure.id">
                     {{measure.UomName}}
                    </option>
            </select>
             <label for="">Remarks</label>
            <input type="text" class="default_input reference-form" formControlName="Remarks" />
          </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(lossOfUseItemsForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(lossOfUseItemsForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Loss of use items"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 

          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(lossOfUseItemss | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectLossOfUseItems(option.id)"
                  *ngFor="let option of result"
                  [value]="option.LossOfUseItemDesc"
                  [value]="option.Rate"
                  [value]="option.UomId"
                  [value]="option.Remarks"
                >
                  {{ option. LossOfUseItemDesc}}
                  {{ option.Rate }}
                  {{ option.Remarks }}
                   {{ option.UomId }}
                   {{ option.Remarks }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>

        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">LossOfUse Desc</span>
          <span class="item">Rate</span>
          <span class="item">Measure</span>
          <span class="item">Remarks</span>
          <span class="item">Action</span>

        </div>

      <div class="scroll">

      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let lossOfUseItems of lossOfUseItemsFormArray.get('LossOfUseItemss')['controls']; index as i"
        (click)="onEdit(i, lossOfUseItems.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{lossOfUseItems.value.LossOfUseItemDesc}}</span>
          <span class="content">{{lossOfUseItems.value.Rate}}</span>
          <span class="content">{{getUOMName(lossOfUseItems.value.UomId)}}</span>
          <span class="content">{{lossOfUseItems.value.Remarks}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"

            (click)="deleteLossOfUseItems(i, lossOfUseItems.value)">
            <em class="ti-trash"> </em> </button>
          </span>

        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(lossOfUseItemsFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>

  <div class="box green_box"></div>
  <div class="box pink_box"></div>
